/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { action, makeObservable } from 'mobx';

import type { ToolbarGroupItem } from '@veeam/components/lib/Toolbar/types';
import type { CommandMenuItemConfig } from '@veeam/components';

import { toolbarActionToCommandAction } from '../../../helpers';

import type { ToolbarItem } from '../../../../Toolbar/interfaces';

export class ContextMenuStore {
    contextMenuActions: CommandMenuItemConfig[] = [];

    constructor() {
        makeObservable(this);
    }

    @action.bound
    appendContextMenu(toolbarActions: ToolbarItem[] = [], toolbarGroups: ToolbarGroupItem[] = []): void {
        const actions = toolbarActions.filter(x => !x.removeFromContextMenu);

        const actualActions = toolbarActionToCommandAction(actions, toolbarGroups);

        if (actualActions.length) {
            this.contextMenuActions = actualActions;
        }
    }
}
